export default __webpack_public_path__ + "static/8-2679c774261bab3e6bae629af79c03a9.jpg";